<section class="card">
    <header class="event-header">
        <div class="event-details">
            <h5 class="event-customer-name">
                Send Crew Schedule
            </h5>
            <span class="event-time">Today, Jun 12 2024</span>
        </div>
        <div class="event-actions">
            <p-button
                label="Cancel"
                (onClick)="onClose()"
                [outlined]="true"
                severity="secondary"
            />
            <p-button
                label="Send"
                icon="pi pi-check"
                [disabled]="!(selectedWorkingCrew$ | async)?.length"
                (onClick)="onSave()"
            />
        </div>
    </header>
    <p-divider></p-divider>
    <main>
        <div>
            <label for="crew-schedule-recepients">To</label>
            <p-multiSelect
                #multiSelect
                inputId="crew-schedule-recepients"
                class="full-width-multiselect"
                [options]="workingCrew$ | async"
                [ngModel]="selectedWorkingCrew$ | async"
                (onChange)="onCrewSelect($event)"
                optionLabel="name"
                display="chip"
                [showClear]="true"
                [selectedItemsLabel]="'{0} Crew Selected'"
            />
        </div>
        <div class="p-mt-4">
            <label for="subject">Subject</label>
            <quill-editor
                id="subject"
                class="subject-editor p-mt-1"
                #subjectEditor
                [(ngModel)]="subjectContents"
                format="object"
                [modules]="subjectModules"
                placeholder="Write schedule subject here"
                appQuillTemplateVariableToolbar
                [templatesAndVariables$]="templatesAndVariables$"
                [templateVariablesData$]="templateVariableData$"
                [setDefaultTemplate]="true"
                [isSubject]="true"
            />
        </div>

        <quill-editor
            class="p-mt-4"
            #editor
            [(ngModel)]="editorContents"
            format="object"
            [modules]="editorModules"
            (onEditorCreated)="onEditorCreated($event)"
            placeholder="Write schedule details here"
            appQuillTemplateVariableToolbar
            [templatesAndVariables$]="templatesAndVariables$"
            [templateVariablesData$]="templateVariableData$"
            [setDefaultTemplate]="true"
        >
        </quill-editor>
    </main>
</section>